import { useAuthContext } from '../../auth/AuthContext';
import PageTemplate from '../../components/PageTemplate/PageTemplate';
import { P } from '../../components/ui';
import { useFormConfig } from '../../hooks/useFormConfig';

export default function TenantAccessDeniedScreen() {
  const { signOut, user } = useAuthContext();
  const { formConfig } = useFormConfig();
  const serviceName = formConfig?.formName || 'this service';
  const contactEmail = formConfig?.feedbackEmail;

  return (
    <PageTemplate>
      <h1 className="govuk-heading-l">You do not have access to this service</h1>
      <P>
        {user?.email ? `${user.email} is` : 'You are'} signed in, but your account has not been given
        access to {serviceName}.
      </P>
      <P>
        {contactEmail ? (
          <>
            If you think you should have access, contact{' '}
            <a className="govuk-link" href={`mailto:${contactEmail}`}>
              {contactEmail}
            </a>
            .
          </>
        ) : (
          'If you think you should have access, contact the team that runs this form.'
        )}
      </P>
      <button type="button" className="govuk-button" onClick={() => void signOut()}>
        Sign out
      </button>
    </PageTemplate>
  );
}
